import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'

import { ddUsersAPI } from '../api/services/users'

export const useChangePasswordForm = () => {
  const onSubmitChangePassword = async (
    values: {
      oldPassword: string
      password: string
      passwordConfirmation: string
    },
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    const toastId = toast.loading('Wysyłanie danych')
    setSubmitting(true)

    try {
      const response = await ddUsersAPI.changePassword({
        old_password: values.oldPassword,
        new_password: values.password
      })

      const existsErrors =
        response?.error && Object.keys(response.error).length > 0

      if (existsErrors) {
        response?.error &&
          Object.keys(response.error).map((key) => {
            const errors = response.error ? response.error[key] : []

            if (key === 'old_password') {
              formik.setFieldError('oldPassword', errors.join(', '))
            }
            if (key === 'new_password') {
              formik.setFieldError('password', errors.join(', '))
            }
          })
      }

      if (response.status === 200) {
        formik.values.oldPassword = ''
        formik.values.password = ''
        formik.values.passwordConfirmation = ''

        toast.update(toastId, {
          render: 'Hasło zostało zmienione',
          type: 'success',
          delay: 500,
          isLoading: false,
          autoClose: 4000
        })
      }
      if (response.status === 400) {
        toast.dismiss(toastId)
      }
    } catch {
      toast.dismiss(toastId)
    } finally {
      setSubmitting(false)
    }
  }

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required('To pole jest wymagane'),
    password: Yup.string()
      .required('To pole jest wymagane')
      .min(8, 'Twoje hasło musi zawierać co najmniej 8 znaków'),
    passwordConfirmation: Yup.string()
      .required('To pole jest wymagane')
      .min(8, 'Twoje hasło musi zawierać co najmniej 8 znaków')
      .test(
        'is-same',
        'W tym polu hasło musi być powtórzone nowe hasło',
        function (value) {
          const { password } = this.parent
          return value === password
        }
      )
  })

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      password: '',
      passwordConfirmation: ''
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      await onSubmitChangePassword(values, setSubmitting)
    }
  })

  return { formik }
}
